import styled from 'styled-components';

import { Button } from '../../../Button';
import FormCard from '../../../FormCard';

const AddAnotherButton = styled(Button)`
  align-self: flex-end;
  margin-top: 25px;
  background-color: white;
  border: 2px solid var(--cargill-green);
  padding: 10px 30px;
  font: var(--sprout-font-body1-bold);
`;

interface AddAnotherShipToCardProps {
  onClick?: () => void;
}

const AddAnotherShipToCard = ({ onClick }: AddAnotherShipToCardProps) => {
  const cardProps = {
    title: 'Add Another Ship To',
    subtitle: ``,
    image: '/food/onboarding/assets/Ship_To_Address.svg'
  };

  return (
    <FormCard {...cardProps}>
      <AddAnotherButton type="button" onClick={onClick}>
        Add Ship To
      </AddAnotherButton>
    </FormCard>
  );
};

export default AddAnotherShipToCard;
